<template>
  <div
    id="main"
    ref="main"
    @click="$hub.emit('clicked')"
    @mousemove="onMouseMove"
    :class="{'is-full': $route.meta.isFull}"
    class="u-full-width u-relative u-overflow-hidden u-antialiased"
  >
    <symbols-svg />
    <div ref="containerWebGL" class="u-wrapper-panel"/>
    <!-- <router-view v-slot="{ Component }">
      <transition name="t-fader">
        <component :is="Component" />
      </transition>
    </router-view> -->
    <scene />

    <div ref="containerCSS3D" class="u-wrapper-panel u-overflow-hidden"/>

    <debugger v-if="$route.query.debug" />
    <img alt="Vue logo" src="./assets/logo.png">
  </div>
</template>

<script>
import { OrbitControls } from 'shimmer'

import App from './App'

import SymbolsSvg from '@/components/SymbolsSvg'
import Debugger from '@/components/Debugger'
import Scene from '@/components/Scene'

import { webGL } from '@/webGL/WebGL'

export default {
  name: 'App',

  mixins: [App],

  components: {
    SymbolsSvg,
    Debugger,
    Scene
  },

  created () {
    this.pointerevent = null
  },

  mounted () {
    webGL.camera.position.set(0, 10, 20)
  }
}
</script>

<style lang="stylus" src="./styles/theme.styl"/>

<style lang="stylus">
// @import '~@/styles/settings/variables'

#main
  min-height 100vh

  &.is-full
    position fixed
    top .2px
    bottom .2px
    left 0
    right 0
    overflow hidden
    min-height auto

</style>